import styles from './QuickSearchLink.less';

import NavLink from 'src/components/NavLink/NavLink';
import React from 'react';
import PropTypes from 'prop-types';
import { Text, TextLink } from 'seek-style-guide/react';

const QuickSearchLink = ({ children, linkProps }) => (
  <Text small className={styles.root}>
    <NavLink component={TextLink} className={styles.link} {...linkProps}>
      {children}
    </NavLink>
  </Text>
);

QuickSearchLink.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  linkProps: PropTypes.object.isRequired
};

export default QuickSearchLink;
